// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getMessaging} from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBD7Pe01FJWiJG-TOroHIDHRPS0paBMlz0",
  authDomain: "blinkkopticals-6c609.firebaseapp.com",
  projectId: "blinkkopticals-6c609",
  storageBucket: "blinkkopticals-6c609.appspot.com",
  messagingSenderId: "597509502102",
  appId: "1:597509502102:web:5c8028c293b11d34d27eb7",
  measurementId: "G-993X7R0K11"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
// const analytics = getAnalytics(app);